/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBatteryCharge = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7 6v2H4v8h3v2H2V6zm13 0v4h2v4h-2v4h-5v-2h3V8h-3V6zm-7 0-3 5h5l-4 7H9l3-5H7l4-7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBatteryCharge as BatteryCharge };
